module.exports = __webpack_public_path__ + "img/国开本科法学.b8be6bfc.png";